import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import lottie from 'lottie-web';
import styles from './Loader.module.scss';
import TestIds from '../../tests/TestIds';
import animationData from './spectrocoin_loader.json';

interface Props {
	className?: string;
}

const Loader = ({ className }: Props) => {
	const element = useRef<HTMLDivElement>(null);

	useEffect(() => {
		lottie.loadAnimation({
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData,
			container: element.current!,
		});
	}, [element]);

	return (
		<div
			data-cy={TestIds.Loader}
			ref={element}
			className={classNames(styles.loader, className)}
		/>
	);
};

export default Loader;
